import { cva, type VariantProps } from 'class-variance-authority';
import styles from './modal.module.css';

export type ModalVariants = VariantProps<typeof variants>;
export type PadVariants = VariantProps<typeof padVariants>;

const size = {
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg,
};

const pad = {
  lg: styles['pad-lg'],
  xl: styles['pad-xl'],
  xxl: styles['pad-xxl'],
};

export const variants = cva(styles.popup, {
  variants: { size },
});

export const padVariants = cva('', {
  variants: { pad },
});
